import { Controller } from "@hotwired/stimulus"

const COUNTRIES = [
  { code: "BR", ddi: "55", flag: "🇧🇷", mask: "(##) #####-####", maxDigits: 11 },
  { code: "US", ddi: "1",  flag: "🇺🇸", mask: "(###) ###-####",  maxDigits: 10 },
  { code: "PT", ddi: "351", flag: "🇵🇹", mask: "### ### ###",    maxDigits: 9 },
  { code: "AR", ddi: "54", flag: "🇦🇷", mask: "## ####-####",   maxDigits: 10 },
  { code: "MX", ddi: "52", flag: "🇲🇽", mask: "## #### ####",   maxDigits: 10 },
  { code: "CO", ddi: "57", flag: "🇨🇴", mask: "### ### ####",   maxDigits: 10 },
  { code: "CL", ddi: "56", flag: "🇨🇱", mask: "# #### ####",    maxDigits: 9 },
  { code: "PE", ddi: "51", flag: "🇵🇪", mask: "### ### ###",    maxDigits: 9 },
  { code: "UY", ddi: "598", flag: "🇺🇾", mask: "## ### ###",    maxDigits: 8 },
  { code: "PY", ddi: "595", flag: "🇵🇾", mask: "### ### ###",   maxDigits: 9 },
  { code: "GB", ddi: "44", flag: "🇬🇧", mask: "#### ######",    maxDigits: 10 },
  { code: "DE", ddi: "49", flag: "🇩🇪", mask: "#### #######",   maxDigits: 11 },
  { code: "FR", ddi: "33", flag: "🇫🇷", mask: "# ## ## ## ##",  maxDigits: 9 },
  { code: "ES", ddi: "34", flag: "🇪🇸", mask: "### ### ###",    maxDigits: 9 },
  { code: "IT", ddi: "39", flag: "🇮🇹", mask: "### ### ####",   maxDigits: 10 },
  { code: "JP", ddi: "81", flag: "🇯🇵", mask: "##-####-####",   maxDigits: 10 },
]

export default class extends Controller {
  static targets = ["select", "input", "hidden"]

  connect() {
    this._country = COUNTRIES[0] // Brasil default
    this._updatePrefix()
    this.inputTarget.addEventListener("input", this._onInput)
    this.inputTarget.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this._onInput)
    this.inputTarget.removeEventListener("keydown", this._onKeydown)
  }

  changeCountry() {
    const code = this.selectTarget.value
    this._country = COUNTRIES.find(c => c.code === code) || COUNTRIES[0]
    this._updatePrefix()
    this.inputTarget.value = ""
    this._syncHidden()
    this.inputTarget.focus()
  }

  _updatePrefix() {
    this.inputTarget.placeholder = this._country.mask.replace(/#/g, "0")
  }

  _onInput = () => {
    this._applyMask()
    this._syncHidden()
  }

  _onKeydown = (e) => {
    if (e.key === "Backspace") {
      const pos = this.inputTarget.selectionStart
      const val = this.inputTarget.value
      if (pos > 0 && /[^0-9]/.test(val[pos - 1])) {
        e.preventDefault()
        let newPos = pos - 1
        while (newPos > 0 && /[^0-9]/.test(val[newPos - 1])) newPos--
        if (newPos > 0) {
          const digits = val.replace(/\D/g, "")
          const trimmed = digits.slice(0, -1)
          this.inputTarget.value = trimmed
          this._applyMask()
          this._syncHidden()
        }
      }
    }
  }

  _applyMask() {
    const digits = this.inputTarget.value.replace(/\D/g, "").slice(0, this._country.maxDigits)
    const mask = this._country.mask
    let result = ""
    let di = 0

    for (let i = 0; i < mask.length && di < digits.length; i++) {
      if (mask[i] === "#") {
        result += digits[di++]
      } else {
        result += mask[i]
      }
    }

    this.inputTarget.value = result
  }

  _syncHidden() {
    const digits = this.inputTarget.value.replace(/\D/g, "")
    this.hiddenTarget.value = digits ? `+${this._country.ddi}${digits}` : ""
  }
}
